import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useAuth } from '../contexts/AuthContext';

// 이미지 import
import logoImg from '../assets/logo.png';
import waveBg from '../assets/blending.png';
import loginIcon from '../assets/Login.svg';

const LoginPage = () => {
  const { signIn } = useAuth();
  
  const handleSignIn = (e) => {
    e.preventDefault();
    signIn();
  };
  
  return (
    <LoginPageContainer>
      <LoginContent>
        <LogoContainer>
          <LogoBox />
          <LogoText>Voice Fit</LogoText>
        </LogoContainer>
        <Tagline>Just Say It — Track Your Workout</Tagline>
        
        <ButtonContainer>
          <SignInButton onClick={handleSignIn}>
            <LoginIconImg src={loginIcon} alt="login" /> Sign in
          </SignInButton>
          <PreviewButton to="/preview">
            Preview
          </PreviewButton>
        </ButtonContainer>
      </LoginContent>
      <WaveBackground />
    </LoginPageContainer>
  );
};

const LoginPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
  background-color: white;
  position: relative;
  overflow: hidden;
`;

const LoginContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 2rem;
  flex: 1;
  z-index: 10;
  margin-top: 20vh;
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: .6rem;
`;

const LogoBox = styled.div`
  width: 36px;
  height:36px;
  background-color: #DE3238;
  background-image: url(${logoImg});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 8px;
  margin-right: 10px;
//   box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LogoText = styled.h1`
  font-size: 2.6rem;
  font-weight: bold;
  color: #000;
`;

const Tagline = styled.p`
  font-size: .9rem;
  color: #666;
  margin-bottom: 4rem;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 220px;
  gap: 1rem;
`;

const LoginIconImg = styled.img`
  width: 20px;
  height: 18px;
  margin-right: 8px;
`;

const SignInButton = styled.button`
  background-color: #DE3238;
  color: white;
  padding: 0.8rem 1.5rem;
  font-size: 1rem;
  border-radius: 50px;
  text-align: center;
  text-decoration: none;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
  
  &:hover {
    background-color: #c5292e;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

const PreviewButton = styled(Link)`
  background-color: #a9b6c5;
  color: white;
  padding: 0.6rem 1.5rem;
  font-size: 1rem;
  border-radius: 50px;
  text-align: center;
  text-decoration: none;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  
  &:hover {
    background-color: #98a7b8;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

const WaveBackground = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 345px;
  background-image: url(${waveBg});
  background-size: cover;
  background-position: center bottom;
  z-index: 1;
  
  /* 모바일에서는 바닥에 붙임 */
  bottom: 0;
  
  /* 데스크탑에서는 하단에서 200px 띄움 */
  @media (min-width: 555px) {
    width: 400px;
    bottom: 100px;
    border-radius: 25px;
  }
`;

export default LoginPage; 